(function () {
  'use strict';

  angular
    .module('importacaoPontoReferencia')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('root.importacaoPontoReferencia', {
        url: '/importacao-ponto-referencia',
        views: {
          'content@': {
            templateUrl: 'importacao-ponto-referencia/importacao-ponto-referencia.tpl.html',
            controller: 'ImportacaoPontoReferenciaCtrl',
            controllerAs: 'importacaoPontoReferencia'
          }
        },
        data: {
          titulo: 'core-permissoes.organizacao.importacaoPontoReferencia.titulo',
          role: 'UO_EDITAR'
        }
      });
  }
}());
